$ = require 'jquery'
AutoMentionerView = require 'views/internal/autocomplete/auto-mentioner-view'
DragSort = require 'views/lib/drag-sort'
EmojiCompleterView = require 'views/internal/autocomplete/emoji-completer-view'
hasSelectionIn = require 'lib/util/selection/has-selection-in'
Keyboard = require 'lib/keyboard'
Keys = require 'data/keys'
Layout = require 'views/lib/layout'
PopOver = require 'views/lib/pop-over'
Storage = require 'lib/storage'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
log = require 'debug/log'
templates = require 'views/internal/templates'
l = require 'lib/localize'
formatNumber = require 'lib/format/number'

module.exports = class EditableView extends View
  allowNewlines: true

  _draftKey: (attr) -> "draft_#{ @model.id }_#{ attr }"
  _saveDraft: (attr, value) -> Storage.set(@_draftKey(attr), value)
  _recallDraft: (attr) -> Storage.get(@_draftKey(attr))
  _discardDraft: (attr) -> Storage.unset(@_draftKey(attr))

  editField: (e) ->
    $link = $(e.target).closest('a')
    return if ($link.length > 0 && $link.attr('href') != '#')
    return if DragSort.sorting

    $container = $(e.target).closest('.editable')
    if $container.length == 0
      return

    # If they've selected some text, they're probably trying to copy it
    if hasSelectionIn($container)
      return

    Util.stop(e)
    PopOver.hide()

    attr = $container.attr('attr')

    @edit(attr)

  edit: (sAttr, focus = true) ->
    if sAttr.indexOf('.') > -1
      parts = sAttr.split('.')
      sAttr = parts[1]

    allEditableWithAttr = @$("[attr=#{sAttr}]")
    noEdits = @$(".js-no-higher-edits [attr=#{sAttr}]")
    container = allEditableWithAttr.not(noEdits)
    return if (container.length == 0)

    Layout.cancelEdits()
    edit = container.find('.edit:first')
    return if (edit.length == 0)

    input = container.find('.field:first')
    isTextArea = input.is('textarea')
    isCardDesc = input.parent().is('.card-detail-edit')
    current = container.find('.current')

    edit.append(templates.fill('edit_controls'))

    if (!edit.hasClass('delete'))
      edit.find('.delete').remove()
    if (!edit.hasClass('convert'))
      edit.find('.convert').remove()
    if (!edit.hasClass('options-menu'))
      edit.find('.options-menu').remove()
    if (!edit.hasClass('add-members'))
      edit.find('.add-members').remove()

    container.addClass('editing')

    if input.val() == ""
      input.val(Util.traverse(@model.attributes, parts ? sAttr))

    @waitForId @model, =>
      input.data('draftKey', @_draftKey(sAttr))

    log('editable', @model)

    if focus
      input.focus().select()
    input.autosize(append: false)
    return

  recallDrafts: ->
    view = @
    $allEdits = @$('[attr]')
    # Make sure we don't process other editables that are nested
    # inside this one
    $noEdits = @$('.js-no-higher-edits [attr]')

    $allEdits.not($noEdits).each (index, el) =>
      $el = $(el)
      attr = $el.attr('attr')
      if @model.id?
        draftVal = view._recallDraft(attr)
        if draftVal?
          $input = $el.find('.field:first')
          $input.val(draftVal)
          @defer =>
            $el.find('.edits-warning').show()
      return

  stopEditing: (e) ->
    Util.stop(e)
    Layout.cancelEdits()
    false

  clearEdits: (e) ->
    Util.stop(e)
    # Layout.clearEdits()
    $editable = $(e.target).closest('.editable[attr]')
    attr = $editable.attr('attr')
    if attr?
      @_discardDraft(attr)
    $editable.find('.field').val("")
    $editable.find('.edits-warning').hide()
    $editable.find('.edits-error').hide()
    Layout.cancelEdits()
    false

  validate: ->
    for field in @$('.editing.non-empty .field')
      if /^\s*$/.test($(field).val())
        return false

    for field in @$('.editing .field')
      fieldLength = ($(field).val() ? '').length
      if fieldLength > 16384
        $('.editing')
        .find '.edits-error'
        .text l('text too long', { over: formatNumber(fieldLength - 16384) })
        .show()
        return false

    true

  keydownEvent: (e) ->
    key = Keyboard.getKey(e)

    if Layout.isEditing()

      if (PopOver.view instanceof EmojiCompleterView) || (PopOver.view instanceof AutoMentionerView)
        @checkInsert?(e)

      else if Keyboard.isForceSubmitEvent(e) or ((key == Keys.Enter && (!$(e.target).is("textarea") || $(e.currentTarget).hasClass('single-line'))) and !e.shiftKey)
        Util.stop(e)
        @commitEdits(e)

      else if key == Keys.Enter && !@allowNewlines
        Util.stop(e)

    return

  commitEdits: (e) ->
    Util.stop(e)

    $editable = $(e.target).closest('.editable.editing[attr]')
    $editable.find('.edits-error').hide()

    if !@validate()
      return

    view = @
    model = @model
    customSet = @customSet

    # Remove buttons
    $editable.remove('input[type=submit]')

    # Remove buttons and commit all other edits
    $editable
    .removeClass('editing')
    .each(->
      attr = $(this).attr('attr')
      newValue = $(this).find('.field').val()

      if !view.allowNewlines
        newValue = newValue.replace(/[\r\n]+/g, ' ')

      # if the newValue is all whitespace, replace it with the empty string
      if $.trim(newValue).length == 0
        newValue = ""

      if model.get(attr) == newValue
        view._discardDraft(attr)
      else
        model.update attr, newValue, (err) ->
          if err?
            $editable.find('.edits-error').text(err.message).show()
          else
            view._discardDraft(attr)
          return
    )
    .find('.field').val("")

    $editable.find('.edits-warning').hide()

    true

  clickSetting: (e) ->
    $target = $(e.target)
    if $target.hasClass('disabled') || $target.closest('.js-disabled').length
      return

    # If this is an actual link, let it through
    href = $target.attr('href')
    if href && href != '#'
      return

    prefName = $target.closest('.pref').attr('name')
    if !prefName
      return
    setting = $target.attr('value')

    setting =
      switch setting
        when 'true' then true
        when 'false' then false
        else setting

    @model.setPref(prefName, setting)
    @model.save()

    Util.stop(e)
    return

  delegateEvents: (events) ->
    editableEvents =
      'click .current': 'editField'
      'click .js-cancel-edit': 'clearEdits'
      'click .js-discard-edits': 'clearEdits'
      'click .js-view-edits': 'editField'
      'click .js-save-edit': 'commitEdits'
      'keydown .field': 'keydownEvent'
      'click input': Util.stopPropagation
      'click textarea': Util.stopPropagation

    if @model.setPref?
      editableEvents['click a'] = 'clickSetting'

    super(_.extend(editableEvents, events || @events))



// WEBPACK FOOTER //
// ./app/scripts/views/internal/editable-view.coffee